export default __webpack_public_path__ + "static/media/playlists-example.eead0c65.png";